import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'
import { keycloak } from '#shared/lib/auth'
import resolveApiUrl from './resolve-api-url'

const MIN_VALIDITY_SEC = 10

const connection = new HubConnectionBuilder()
  .withUrl(resolveApiUrl('@sd-notifications/notifications'), {
    accessTokenFactory: async () => {
      await keycloak.updateToken(MIN_VALIDITY_SEC)
      return keycloak.token ?? ''
    },
    withCredentials: true,
  })
  .configureLogging(LogLevel.Trace)
  .build()

export default connection

connection.on('order-status-updated-v1', data => {
  console.log('order-status-updated-v1', data)
})
